
import React, { useState, useEffect } from 'react';

function ClientsReview() {
    const [currentIndex, setCurrentIndex] = useState(0);

    const reviews = [
        {
            id: 1,
            name: "Ritika Chaudhary",
            image: "ClientsReview/client-1.webp",
            rating: 5,
            review: "Shivani and her team are PPC wizards! Our ROI has never been better. "
        },
        {
            id: 2,
            name: "Satendra Kumar",
            image: "ClientsReview/client-2.webp",
            rating: 5,
            review: "Their SEO and content strategies helped our business rank on the first page of Google within months!"
        },
        {
            id: 3,
            name: "Mukul Singh",
            image: "ClientsReview/client-3.webp",
            rating: 4,
            review: "Working with Digital Canto has been a game-changer for our marketing campaigns. Their expertise in paid ads is unmatched."
        },
        {
            id: 4,
            name: "Arvind Singh",
            image: "ClientsReview/client-4.webp",
            rating: 5,
            review: "The team at Digital Canto is professional, knowledgeable, and results-driven. Our lead generation has skyrocketed"
        },
        {
            id: 5,
            name: "Rohit Kumar",
            image: "ClientsReview/client-5.webp",
            rating: 3,
            review: "Their tailored Local SEO marketing strategies have made a significant impact on our brand awareness and customer engagement"
        },
        {
            id: 6,
            name: "Aradhna Saini",
            image: "ClientsReview/client-6.webp",
            rating: 4,
            review: "Thanks to Digital Canto, our website traffic has increased significantly, leading to more conversions and sale"
        },
        {
            id: 7,
            name: "Gaurav Gautam",
            image: "ClientsReview/client-7.jpeg",
            rating: 5,
            review: "Digital Canto helped us create compelling ad campaigns that truly resonate with our audience. Fantastic results!"
        }
    ];

    // Responsive slide count
    const getSlidesPerView = () => {
        if (typeof window !== 'undefined') {
            if (window.innerWidth < 640) return 1;
            if (window.innerWidth < 1024) return 2;
            return 4; // Desktop: 4 slides
        }
        return 4;
    };

    const slidesPerView = getSlidesPerView();
    const totalSlidesGroups = Math.ceil(reviews.length / slidesPerView);

    // Auto-scroll functionality
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) =>
                prevIndex >= reviews.length - slidesPerView ? 0 : prevIndex + 1
            );
        }, 4000);

        return () => clearInterval(interval);
    }, [reviews.length, slidesPerView]);

    // Handle resize
    useEffect(() => {
        const handleResize = () => {
            setCurrentIndex(0);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const StarRating = ({ rating }) => (
        <div className="flex mb-3">
            {[...Array(5)].map((_, index) => (
                <svg
                    key={index}
                    className={`w-5 h-5 transition-all duration-200 ${index < rating ? 'text-yellow-400 fill-current' : 'text-gray-300'
                        }`}
                    fill="currentColor"
                    viewBox="0 0 20 20"
                >
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
            ))}
        </div>
    );

    return (
        <div className="clients-review-section bg-gradient-to-brpy-20 overflow-hidden">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">

                <div className="text-center mb-20">
                    <span className="inline-block px-6 py-3 bg-gradient-to-r from-purple-500 to-pink-500 bg-clip-text text-transparent text-lg font-semibold tracking-wider mb-4">
                        TESTIMONIALS
                    </span>
                    <h1 className="text-4xl sm:text-xl md:text-4xl lg:text-4xl font-black bg-gradient-to-r from-gray-900 via-gray-800 to-slate-900 bg-clip-text text-transparent mb-6 leading-tight">
                        What Our <span className='text-secondary font-semibold'>HAPPY</span> Clients Say
                    </h1>
                    <div className="w-24 h-1 bg-gradient-to-r from-purple-500 to-pink-500 mx-auto rounded-full" />
                </div>


                <div className="relative">
                    <div className="overflow-hidden rounded-2xl">
                        <div
                            className="slider-container flex transition-transform duration-1000 ease-out h-full"
                            style={{
                                transform: `translateX(-${(currentIndex * (100 / slidesPerView))}%)`
                            }}
                        >
                            {reviews.map((review, index) => (
                                <div
                                    key={review.id}
                                    className={`review-card-wrapper flex-shrink-0 px-2 sm:px-3 transition-all duration-300 ${slidesPerView === 1 ? 'w-full' :
                                            slidesPerView === 2 ? 'w-1/2 md:w-1/2' :
                                                'w-1/4'
                                        }`}
                                >
                                    <div className="review-card group bg-white/90 backdrop-blur-xl rounded-3xl p-6 sm:p-8 h-full shadow-2xl hover:shadow-3xl border border-white/50 hover:border-purple-100 transition-all duration-500 hover:-translate-y-3 hover:scale-[1.02] min-h-[300px] flex flex-col justify-between">

                                        {/* Stars */}
                                        <div className="mb-4 sm:mb-8 flex-shrink-0">
                                            <StarRating rating={review.rating} />
                                        </div>

                                        {/* Review Text */}
                                        <p className="text-gray-700 text-base sm:text-lg leading-relaxed mb-6 sm:mb-8 font-light italic group-hover:text-gray-900 transition-colors duration-300 flex-1 line-clamp-4">
                                            "{review.review}"
                                        </p>

                                        {/* User Info */}
                                        <div className="flex items-center pt-4 sm:pt-6 border-t border-gray-100 flex-shrink-0">
                                            <img
                                                src={review.image}
                                                alt={review.name}
                                                className="w-12 h-12 sm:w-14 sm:h-14 rounded-2xl ring-4 ring-purple-100/50 group-hover:ring-purple-200 transition-all duration-300 object-cover flex-shrink-0"
                                            />
                                            <div className="ml-3 sm:ml-4 min-w-0">
                                                <h3 className="font-bold text-lg sm:text-xl text-gray-900 group-hover:text-purple-600 transition-colors truncate">
                                                    {review.name}
                                                </h3>
                                                <div className="flex items-center mt-1">
                                                    <div className="w-2 h-2 bg-green-400 rounded-full mr-2 animate-pulse" />
                                                    <span className="text-xs sm:text-sm text-green-600 font-medium">Verified</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="absolute inset-0 bg-gradient-to-t from-purple-500/5 to-transparent rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Navigation Dots */}
                    <div className="flex justify-center mt-12 space-x-2">
                        {Array.from({ length: totalSlidesGroups }).map((_, idx) => (
                            <button
                                key={idx}
                                onClick={() => setCurrentIndex(idx * slidesPerView)}
                                className={`w-3 h-3 rounded-full transition-all duration-300 shadow-md ${Math.floor(currentIndex / slidesPerView) === idx
                                        ? 'bg-gradient-to-r from-purple-500 to-pink-500 scale-125 shadow-lg'
                                        : 'bg-white/60 hover:bg-purple-200'
                                    }`}
                            />
                        ))}
                    </div>


                    <div className="text-center mt-8 text-sm text-gray-500 font-medium animate-pulse">

                    </div>
                    {slidesPerView === 1 && (
                        <div className="absolute top-1/2 -translate-y-1/2 left-4 right-4 flex justify-between pointer-events-none sm:hidden">
                            <button
                                onClick={() => setCurrentIndex(prev => prev > 0 ? prev - 1 : 0)}
                                className="pointer-events-auto bg-white/90 backdrop-blur-sm p-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110"
                            >
                                <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                                </svg>
                            </button>
                            <button
                                onClick={() => setCurrentIndex(prev => prev < reviews.length - 1 ? prev + 1 : reviews.length - 1)}
                                className="pointer-events-auto bg-white/90 backdrop-blur-sm p-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110"
                            >
                                <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                </svg>
                            </button>
                        </div>
                    )}
                </div>
            </div>

            <style jsx>{`
                .line-clamp-4 {
                    display: -webkit-box;
                    -webkit-line-clamp: 4;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }
            `}</style>
        </div>
    );
}

export default ClientsReview;
